import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { closeSnackbar, SnackbarProvider } from 'notistack';


export default function CustomizedSnackbarProvider({ children }) {
    return (
        <SnackbarProvider
            maxSnack={3}
            autoHideDuration={null}
            action={(snackbarKey) => (
                <IconButton
                    color="inherit"
                    size="small"
                    onClick={() => closeSnackbar(snackbarKey)}
                    sx={{ color: 'white' }}
                >
                    <Close />
                </IconButton>
            )}
        >
            {children}
        </SnackbarProvider>
    );
}
